import { render, staticRenderFns } from "./NotificationStatus.vue?vue&type=template&id=d410ac70&scoped=true&"
import script from "./NotificationStatus.vue?vue&type=script&lang=js&"
export * from "./NotificationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d410ac70",
  null
  
)

export default component.exports